import gql from "graphql-tag";

export const phaseFragment = gql`
  fragment PhaseFragment on BasePhase {
    id
    name
    rank
    color
  }
`;
